module.exports = __webpack_public_path__ + "images/glass.ce7aa9183639b6faa64d2f4a413426b5.png";